export const getCapitalizedFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase();

export const getUserInitials = (name: string, lastName: string) =>
  `${getCapitalizedFirstLetter(name)}${getCapitalizedFirstLetter(lastName)}`;
